import { CircularProgress } from '@material-ui/core';

export default function Loader({ size = '20px' }) {
  return <CircularProgress size={size} />;
}
